module.exports = __webpack_public_path__ + "img/47-CASACCA-BAROLO-U-COLORI-UNITI-STAMPE-LINO-PANTALONE-MARTE-SMLXL-COLORI-UNITI6.4486de80.jpg";